function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import contains from 'ramda/src/includes';
import curry from 'ramda/src/curry';
import last from 'ramda/src/last';
import map from 'ramda/src/map';
import pipe from 'ramda/src/pipe';
import sort from 'ramda/src/sort';
import i18n from 'invision-core/src/components/i18n/i18n';
import CustomerCareKeys from '../../../../locales/keys';
import { QuantityPricingTypeCodes } from './decisions.constants';
var getPriceTypeOptions = curry(function (priceType, option, billerConfigId, pricingPlansMetadata) {
  if (pricingPlansMetadata) {
    var pricingPlanBillerRuleInstances = pricingPlansMetadata[option.PricingPlanId] && pricingPlansMetadata[option.PricingPlanId].PricingPlanBillerRuleInstances;
    if (pricingPlanBillerRuleInstances) {
      var filteredPricingPlanBillerRuleInstances = [].concat(_toConsumableArray(pricingPlanBillerRuleInstances.RecurringBillerRuleInstances || []), _toConsumableArray(pricingPlanBillerRuleInstances.OneTimeBillerRuleInstances || []));
      var pricingPlanBillerRuleInstance = filteredPricingPlanBillerRuleInstances.find(function (bri) {
        return bri.BillerRuleConfigurationId === billerConfigId;
      });
      if (pricingPlanBillerRuleInstance && pricingPlanBillerRuleInstance.QuantityPricingTypeCode === priceType) {
        return pipe(sort(ascending), map(createQuantityPriceObject), updateLastQuantity)(pricingPlanBillerRuleInstance.BillerRuleInstanceCharges);
      }
    }
  }
  return [];
});
var ascending = function ascending(a, b) {
  return a.StartQuantity - b.StartQuantity;
};
var createQuantityPriceObject = function createQuantityPriceObject(item) {
  var qty = "".concat(item.StartQuantity);
  if (isQuantityARange(item)) {
    qty = "".concat(item.StartQuantity, "-").concat(item.EndQuantity);
  }
  return {
    quantity: qty,
    price: item.ChargeAmount
  };
};
var updateLastQuantity = function updateLastQuantity(tiers) {
  var lastTier = last(tiers);
  if (lastTier && !contains('-', lastTier.quantity)) {
    lastTier.quantity += '+';
  }
  return tiers;
};
var isQuantityARange = function isQuantityARange(item) {
  return item.EndQuantity && item.StartQuantity !== item.EndQuantity;
};
var PricingTypeDecisions = /*#__PURE__*/function () {
  function PricingTypeDecisions(pagesWithDecisions, isDecisionGroupOptionItem) {
    var _this = this;
    _classCallCheck(this, PricingTypeDecisions);
    this.pagesWithDecisions = pagesWithDecisions;
    this.getTieredItems = getPriceTypeOptions(QuantityPricingTypeCodes.TIERED) || [];
    this.getTaperedItems = getPriceTypeOptions(QuantityPricingTypeCodes.TAPERED) || [];
    this.findPricingTypeOptions = getPriceTypeOptions;
    this.createThumbnailTier = curry(function (context, option, priceType, pricingPlanMetadata, isDgoi, bri) {
      var _isDgoi = isDgoi || isDecisionGroupOptionItem;
      context[_isDgoi || isDecisionGroupOptionItem ? option.DecisionGroupOptionItemId : option.Id][bri.BillerRuleConfigurationId] = {
        currencyCode: option.CurrencyCode || option.BillerRuleInstanceThumbnails[0].CurrencyCode,
        description: priceType === QuantityPricingTypeCodes.TIERED ? i18n.translate(CustomerCareKeys.DECISIONS.TIERED_DESCRIPTION) : i18n.translate(CustomerCareKeys.DECISIONS.TAPERED_DESCRIPTION),
        headerItems: [i18n.translate(CustomerCareKeys.DECISIONS.QUANTITY), i18n.translate(CustomerCareKeys.DECISIONS.PRICE)],
        icon: priceType === QuantityPricingTypeCodes.TIERED ? 'tiered' : 'tapered',
        tableItems: priceType === QuantityPricingTypeCodes.TIERED ? _this.getTieredItems(option, bri.BillerRuleConfigurationId, pricingPlanMetadata) : _this.getTaperedItems(option, bri.BillerRuleConfigurationId, pricingPlanMetadata),
        title: priceType === QuantityPricingTypeCodes.TIERED ? i18n.translate(CustomerCareKeys.DECISIONS.TIERED_PRICING) : i18n.translate(CustomerCareKeys.DECISIONS.TAPERED_PRICING)
      };
    });
  }
  return _createClass(PricingTypeDecisions, [{
    key: "createTaperedData",
    value: function createTaperedData(pricingPlansMetadata, isDgoi) {
      return this.createDataFromThumbnails(QuantityPricingTypeCodes.TAPERED, pricingPlansMetadata, isDgoi);
    }
  }, {
    key: "createTieredData",
    value: function createTieredData(pricingPlansMetadata, isDgoi) {
      return this.createDataFromThumbnails(QuantityPricingTypeCodes.TIERED, pricingPlansMetadata, isDgoi);
    }
  }, {
    key: "createDataFromThumbnails",
    value: function createDataFromThumbnails(priceType, pricingPlansMetadata, isDgoi) {
      var _this2 = this;
      var context = {};
      this.pagesWithDecisions.map(function (page) {
        page.decisions.map(function (decision) {
          decision.Options.map(function (option) {
            if (isDgoi) {
              option.Items.map(function (item) {
                context[item.DecisionGroupOptionItemId] = {};
                item.BillerRuleInstanceThumbnails.map(_this2.createThumbnailTier(context, item, priceType, pricingPlansMetadata, true));
              });
            } else {
              context[option.Id] = {};
              option.BillerRuleInstanceThumbnails.map(_this2.createThumbnailTier(context, option, priceType, pricingPlansMetadata, false));
            }
          });
        });
      });
      return context;
    }
  }]);
}();
export { PricingTypeDecisions as default };